import { Component, Mixins, Prop } from 'vue-property-decorator'
import { KFormDatepicker } from '@kwixeo/form-vue'
import { BFormGroup, BRow, BCol, BButton, BModal } from 'bootstrap-vue'
import { CustomerSelect } from '@kwixeo/customers-vue'
import { Spinner, NumberMixin } from '@kwixeo/interface-vue'
import CustomersSales from '../CustomersSales/CustomersSales.vue'
import CustomersWithoutSales from '../CustomersWithoutSales/CustomersWithoutSales.vue'
import { mapGetters } from 'vuex'

@Component({
  components: {
    CustomersSales,
    CustomersWithoutSales,
    KFormDatepicker,
    CustomerSelect,
    Spinner,
    BFormGroup, BRow, BCol, BButton, BModal
  },
  computed: {
    ...mapGetters('user', ['can'])
  }
})
export default class Statistics extends Mixins(NumberMixin) {
  can!: (key: string, level: number) => boolean

  @Prop({ required: true }) type!: string
  @Prop({ required: true }) id!: number

  private loading = false
  private customer: KwixeoCustomers.Customer|null = null
  private since: string|null = null
  private until: string|null = null
  private datas: KwixeoCatalog.SalesStatistics|null = null
  private customerSalesModal = false
  private customerWithoutSalesModal = false

  async mounted (): Promise<void> {
    await this.loadDatas()
  }

  async loadDatas (): Promise<void> {
    this.loading = true
    await this.$kwCatalog.axios.get('/catalog/' + this.type + '/' + this.id + '/statistics', {
      params: {
        since: this.since,
        until: this.until,
        customer: this.customer ? this.customer.id : null
      }
    })
      .then(response => {
        this.datas = response.data
      })
      .finally(() => {
        this.loading = false
      })
  }
}
